import type { InviteLink } from './invite'
import { apiGet, apiSend, apiDelete } from './httpClient'

export function getInviteLinkHttp(tripId: string): Promise<InviteLink | null> {
  return apiGet<InviteLink>(`/trips/${tripId}/invite-link`).catch(() => null)
}

export function createInviteLinkHttpImpl(
  tripId: string,
  role?: string,
  maxUses?: number,
  expiresAt?: string,
): Promise<InviteLink> {
  return apiSend<InviteLink>('POST', `/trips/${tripId}/invite-link`, {
    role,
    max_uses: maxUses,
    expires_at: expiresAt,
  })
}

export function revokeInviteLinkHttp(tripId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/invite-link`)
}

export function joinTripHttp(token: string): Promise<{ trip_id: string; role: string }> {
  return apiSend<{ trip_id: string; role: string }>('POST', `/trips/join/${token}`, {})
}
